<script setup lang="ts">
import type { UserRole } from "@/APIClient";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    role: UserRole;
    clickable?: boolean;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
    clickable: false,
  }
);

function mapRoleToClass(role: string) {
  switch (role) {
    case "ADMIN":
      return "bg-admin";
    case "MANAGER":
      return "bg-manager";
    case "USER":
      return "bg-user";
    case "SUPERADMIN":
      return "bg-superadmin";
    default:
      return "bg-primary";
  }
}

const tagClass = computed(() => mapRoleToClass(props.role));
</script>

<template>
  <el-tag
    effect="dark"
    class="border-0"
    :class="[
      tagClass,
      { 'clickable-badge': clickable, 'cursor-not-allowed': disabled },
    ]"
    >{{ $t(`dashboard.userRole.${props.role}`) }}</el-tag
  >
</template>

<style lang="scss" scoped>
.bg-admin {
  background-color: #ffc107 !important;
}
.bg-manager {
  background-color: #198754 !important;
}
.bg-user {
  background-color: #a4a4a4 !important;
}
.bg-superadmin {
  background-color: #cb1f9d !important;
}

.clickable-badge {
  cursor: pointer;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.05);
  }
}

.cursor-not-allowed {
  cursor: not-allowed !important;
  pointer-events: none;
}
</style>
